module.exports = __webpack_public_path__ + "img/Flag_of_Tanzania.5ec3b115.svg";